import React from 'react';
import { Chip } from '@mui/material';
import { useGetBrokerGroupQuery } from '../../brokerGroups/api/brokerGroupsApi';
import { CopyIdTooltip } from '../CopyIdTooltip';

/**
 * A broker group as a small chip with its name, looked up by doc `id` (getBrokerGroup,
 * filled from the cached broker group list). Until it loads, or for a broker group that no
 * longer exists, the label is the id. Hovering shows the id, with a copy button
 * (CopyIdTooltip), unless showIdTooltip is false (e.g. where the cell has its own tooltip).
 * Other props go to the MUI Chip.
 */
export const BrokerGroupChip = ({ id, showIdTooltip = true, ...chipProps }) => {
	const { data: brokerGroup } = useGetBrokerGroupQuery(id);
	const chip = <Chip size='small' label={brokerGroup?.name ?? id} {...chipProps} />;
	return showIdTooltip ? <CopyIdTooltip id={id}>{chip}</CopyIdTooltip> : chip;
};
